import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import Header from './components/Header23';
import Footer from './components/Footer23';

const Template23Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [rememberMe, setRememberMe] = useState(false);

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        navigate('/template23/shop');
    };

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        border: '1px solid #E8E0D4',
        borderRadius: '8px',
        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
        fontSize: '14px',
        color: '#1B3A2D',
        backgroundColor: '#FFFDF8',
        outline: 'none',
        transition: 'border-color 0.3s ease',
        boxSizing: 'border-box',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito+Sans:wght@300;400;500;600;700&display=swap');

                .utsav-login-container {
                    display: flex;
                    min-height: 100vh;
                    flex-direction: column;
                }
                @media (min-width: 768px) {
                    .utsav-login-container {
                        flex-direction: row;
                    }
                }
                .utsav-login-image {
                    display: none;
                    width: 50%;
                    position: relative;
                }
                @media (min-width: 768px) {
                    .utsav-login-image {
                        display: block;
                    }
                }
                .utsav-login-form-section {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 120px 24px 80px;
                }
                .utsav-login-input:focus {
                    border-color: #C5974B !important;
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FFFDF8' }}>
                <Header cartCount={0} />

                <div className="utsav-login-container">
                    {/* Left: Festive Image */}
                    <div className="utsav-login-image">
                        <img
                            src="https://images.pexels.com/photos/8881954/pexels-photo-8881954.jpeg?auto=compress&cs=tinysrgb&w=1200"
                            alt="Festive Fashion"
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                        <div style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            padding: '60px 40px',
                            background: 'linear-gradient(transparent, rgba(27, 58, 45, 0.9))',
                        }}>
                            <h2 style={{
                                fontFamily: "'Libre Baskerville', Georgia, serif",
                                fontSize: '28px',
                                fontWeight: 700,
                                color: '#FFFFFF',
                                margin: '0 0 8px 0',
                            }}>
                                Celebrate Every Moment
                            </h2>
                            <p style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '15px',
                                color: 'rgba(255,255,255,0.8)',
                                margin: 0,
                                lineHeight: 1.6,
                            }}>
                                Discover handcrafted ensembles for your most cherished celebrations
                            </p>
                        </div>
                    </div>

                    {/* Right: Form */}
                    <div className="utsav-login-form-section">
                        <div style={{ width: '100%', maxWidth: '420px' }}>
                            <div style={{
                                width: '40px',
                                height: '2px',
                                backgroundColor: '#C5974B',
                                marginBottom: '20px',
                            }} />
                            <h1 style={{
                                fontFamily: "'Libre Baskerville', Georgia, serif",
                                fontSize: 'clamp(28px, 4vw, 36px)',
                                fontWeight: 700,
                                color: '#1B3A2D',
                                margin: '0 0 8px 0',
                            }}>
                                Welcome Back
                            </h1>
                            <p style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '15px',
                                color: '#5A5A5A',
                                margin: '0 0 36px 0',
                                lineHeight: 1.6,
                            }}>
                                Sign in to your account to continue your festive shopping
                            </p>

                            <form onSubmit={handleSubmit}>
                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1B3A2D',
                                        display: 'block',
                                        marginBottom: '6px',
                                    }}>
                                        Email Address
                                    </label>
                                    <input
                                        className="utsav-login-input"
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        style={inputStyle}
                                        placeholder="your@email.com"
                                        required
                                    />
                                </div>

                                <div style={{ marginBottom: '20px' }}>
                                    <label style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#1B3A2D',
                                        display: 'block',
                                        marginBottom: '6px',
                                    }}>
                                        Password
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            className="utsav-login-input"
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            style={{ ...inputStyle, paddingRight: '48px' }}
                                            placeholder="Enter your password"
                                            required
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: 'absolute',
                                                right: '14px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: 0,
                                            }}
                                        >
                                            {showPassword
                                                ? <EyeOff size={18} color="#5A5A5A" />
                                                : <Eye size={18} color="#5A5A5A" />
                                            }
                                        </button>
                                    </div>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '28px',
                                }}>
                                    <label style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        cursor: 'pointer',
                                    }}>
                                        <input
                                            type="checkbox"
                                            checked={rememberMe}
                                            onChange={(e) => setRememberMe(e.target.checked)}
                                            style={{ accentColor: '#C5974B', width: '16px', height: '16px' }}
                                        />
                                        <span style={{
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '13px',
                                            color: '#5A5A5A',
                                        }}>
                                            Remember me
                                        </span>
                                    </label>
                                    <button
                                        type="button"
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            color: '#C5974B',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Forgot Password?
                                    </button>
                                </div>

                                <button
                                    type="submit"
                                    style={{
                                        width: '100%',
                                        padding: '16px',
                                        backgroundColor: '#1B3A2D',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '14px',
                                        fontWeight: 700,
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#2D5A45'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#1B3A2D'; }}
                                >
                                    Sign In
                                </button>
                            </form>

                            {/* Divider */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                margin: '28px 0',
                            }}>
                                <div style={{ flex: 1, height: '1px', backgroundColor: '#E8E0D4' }} />
                                <span style={{
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '12px',
                                    color: '#5A5A5A',
                                }}>or</span>
                                <div style={{ flex: 1, height: '1px', backgroundColor: '#E8E0D4' }} />
                            </div>

                            {/* Google Sign In */}
                            <button
                                style={{
                                    width: '100%',
                                    padding: '14px',
                                    backgroundColor: '#FFFFFF',
                                    color: '#1B3A2D',
                                    border: '1px solid #E8E0D4',
                                    borderRadius: '10px',
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '10px',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#C5974B'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#E8E0D4'; }}
                            >
                                <svg width="18" height="18" viewBox="0 0 18 18">
                                    <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
                                    <path fill="#34A853" d="M9.003 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9.003 18z"/>
                                    <path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.332z"/>
                                    <path fill="#EA4335" d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0 5.48 0 2.438 2.017.957 4.958L3.964 7.29c.708-2.127 2.692-3.71 5.036-3.71z"/>
                                </svg>
                                Continue with Google
                            </button>

                            <p style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '14px',
                                color: '#5A5A5A',
                                textAlign: 'center',
                                marginTop: '28px',
                            }}>
                                New here?{' '}
                                <span
                                    onClick={() => navigate('/template23/signup')}
                                    style={{
                                        color: '#C5974B',
                                        fontWeight: 700,
                                        cursor: 'pointer',
                                    }}
                                >
                                    Create an Account
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template23Login;
